import { handleRequest } from "../utilities/requestHandler";

export const getSavedForLaterBySiteId = (selectedSiteData) =>
    handleRequest("post", "/saved_for_later/bysiteid", {
        site_id:selectedSiteData.site_id,
        cus_id: selectedSiteData.cus_id
    });

export const removeFromSavedForLater = (productIds, selectedSiteData, selectedSiteNumber = "") =>
    handleRequest("post", "/saved_for_later/remove", {
        product_ids: productIds,
        site_number:
            selectedSiteNumber ||
            selectedSiteData?.customer_site_number ||
            selectedSiteData?.site_number ||
            "",
        site_id:selectedSiteData?.site_id,
        cus_id: selectedSiteData?.cus_id
    });
